import { motion } from "framer-motion";
import { Undo2, RotateCcw, Home, Trophy, Save, Volume2, VolumeX } from "lucide-react";
import { Button } from "@/components/ui/button";

export const GameControls = ({ 
  onUndo, 
  onReset, 
  onBackToMenu,
  onShowLeaderboard,
  onSaveGame,
  canUndo,
  currentPlayer,
  playerType,
  mode,
  boardSize,
  playerXName = "X",
  playerOName = "O",
  soundEnabled = true,
  onToggleSound
}) => {
  const getWinConditionText = () => {
    if (mode === "classic") return "3 berturut menang";
    if (mode === "gomoku") return "5 berturut menang";
    if (mode === "sos") return "Bentuk SOS";
    return "";
  };

  const getModeText = () => {
    if (mode === "classic") return "Classic";
    if (mode === "gomoku") return "Gomoku";
    if (mode === "sos") return "SOS";
    return mode;
  };
  
  const getCurrentPlayerName = () => {
    if (playerType === "pvp") {
      return currentPlayer === "X" ? playerXName : playerOName;
    }
    return currentPlayer === "X" ? "Kamu" : "AI";
  };

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.1 }}
      className="w-full max-w-md mx-auto"
    >
      {/* Game Info */}
      <div className="glass-card rounded-xl p-3 mb-4">
        <div className="flex justify-between items-center text-sm">
          <span className="font-fredoka text-gold-light">
            {getModeText()} ({boardSize}x{boardSize})
          </span>
          <span className="font-fredoka text-gold-light">
            {getWinConditionText()}
          </span>
        </div>
        {mode !== "sos" && (
          <div className="mt-2 text-center">
            <span className="font-fredoka text-gold-light/80">Giliran: </span>
            <span className={`font-fredoka font-bold text-lg ${currentPlayer === 'X' ? 'text-yellow-300' : 'text-orange-300'}`}>
              {getCurrentPlayerName()}
            </span>
          </div>
        )}
      </div>

      {/* Control Buttons */}
      <div className="flex gap-2 flex-wrap justify-center">
        <Button
          data-testid="undo-button"
          onClick={onUndo}
          disabled={!canUndo}
          variant="outline"
          className="glass-card border-gold/20 text-gold hover:bg-gold/10 disabled:opacity-30 font-fredoka rounded-xl"
        >
          <Undo2 className="w-4 h-4 mr-2" />Undo
        </Button>

        <Button
          data-testid="save-game-button"
          onClick={onSaveGame}
          variant="outline"
          className="glass-card border-gold/20 text-gold hover:bg-gold/10 font-fredoka rounded-xl"
        >
          <Save className="w-4 h-4 mr-2" />Save
        </Button>

        <Button
          data-testid="toggle-sound-button"
          onClick={onToggleSound}
          variant="outline"
          className={`glass-card border-gold/20 hover:bg-gold/10 font-fredoka rounded-xl ${soundEnabled ? 'text-white' : 'text-gold-light/50'}`}
        >
          {soundEnabled ? <Volume2 className="w-4 h-4 mr-2" /> : <VolumeX className="w-4 h-4 mr-2" />}Sound
        </Button>

        <Button
          onClick={onShowLeaderboard}
          variant="outline"
          className="glass-card border-gold/20 text-gold hover:bg-gold/10 font-fredoka rounded-xl"
        >
          <Trophy className="w-4 h-4 mr-2" />Skor
        </Button>

        <Button
          onClick={onBackToMenu}
          variant="outline"
          className="glass-card border-gold/20 text-gold hover:bg-gold/10 font-fredoka rounded-xl"
        >
          <Home className="w-4 h-4 mr-2" />Menu
        </Button>
      </div>
    </motion.div>
  );
};

export default GameControls;
